import React, { useCallback } from 'react';
import { LegalIssuesForm } from '../../../../../../components/LoiForm/LegalIssuesForm';
import { LegalIssueItem } from '../../../../../../slices/marketplace/loi-form/legal-issue-item';
import { LoiForm } from '../../../../../../slices/marketplace/loi-form/loi-form';
import { LoiFormMode } from '../../../../../../slices/marketplace/loi-form/loi-form-mode.enum';
import { LoiFormSection } from '../../../../../../slices/marketplace/loi-form/loi-form-section';
import { TimelineActionType } from '../../../../../../slices/marketplace/timeline/models/timeline-action-type.model';
import './LegalTermGuidance.scss';

interface LegalTermGuidanceProps {
    formData: LoiForm;
    isReadonly: boolean;
    onChange: (legalIssues: LegalIssueItem[], legalIssueSections: LoiFormSection[]) => void;
    invalidItemIds?: Set<string>;
    actionType?: TimelineActionType;
}

export const LegalTermGuidance = (props: LegalTermGuidanceProps) => {
    const handleChange = useCallback((payload: LoiForm) => {
        props.onChange(payload.legalIssues, payload.legalIssueSections);
    }, [props.onChange]);

    if (props.actionType === TimelineActionType.BuyerLoiSubmission) {
        return (
            <div className="legal-issues-tab-body">
                <div className="loi-tab-not-available">Not yet available.</div>
            </div>
        );
    }

    return (
        <div className="legal-issues-tab-body">
            <LegalIssuesForm
                legalIssueSections={props.formData.legalIssueSections ?? []}
                legalIssues={props.formData.legalIssues ?? []}
                termForm={props.formData.termForm}
                onChange={handleChange}
                mode={LoiFormMode.LoiSubmissionEvent}
                readOnly={props.isReadonly}
                invalidItemIds={props.invalidItemIds}
            />
        </div>
    );
};
